import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Youtube = function Youtube(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21.5813 7.1999a2.528 2.528 0 0 0-1.7635-1.8181C18.2542 5 12 5 12 5s-6.2542 0-7.8178.4182a2.527 2.527 0 0 0-1.7635 1.818 26.36 26.36 0 0 0-.4182 4.8089 26.36 26.36 0 0 0 .4182 4.8452 2.527 2.527 0 0 0 1.7635 1.7454c1.5636.4181 7.8178.4181 7.8178.4181s6.2542 0 7.8178-.4181a2.528 2.528 0 0 0 1.7635-1.8181 26.36 26.36 0 0 0 .4182-4.7725 26.36 26.36 0 0 0-.4182-4.8452"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9.75 9.4653c0-.4772 0-.7159.0997-.8491a.5.5 0 0 1 .3647-.1991c.166-.0118.3667.1172.7682.3753l3.9428 2.5347c.3484.2239.5226.3359.5828.4783a.5.5 0 0 1 0 .3892c-.0602.1424-.2344.2544-.5828.4783l-3.9428 2.5347c-.4015.2581-.6022.3872-.7682.3753a.5.5 0 0 1-.3647-.1991c-.0997-.1332-.0997-.3718-.0997-.8491z"
    })]
  }));
};
export default Youtube;